import React, { useContext, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { useTranslate } from "react-admin";
import { addDays, format, isValid, startOfDay } from "date-fns";
import DatePickerFormat from "components/DatePickerFormat";
import { GblContext } from "providers/formatter";
import { updatePaymentClearingDate } from "services/accountPayable";
import SnackbarUtils from "utils/SnackbarUtils";
import { paymentPeriodClosed } from "./clearingDatePolicy";

export default function DialogClearingDate({ payment, onClose, onSaved }) {
  const translate = useTranslate();
  const { settingAll } = useContext(GblContext);
  const [date, setDate] = useState(
    payment.PyhClearDt ? new Date(payment.PyhClearDt) : null,
  );
  const [saving, setSaving] = useState(false);
  const closePeriod = settingAll.SettingClosePeriod.ClosePeriodAp;
  const minDate = new Date(
    Math.max(
      closePeriod ? startOfDay(addDays(new Date(closePeriod), 1)).getTime() : 0,
      payment.PyhChqDt ? startOfDay(new Date(payment.PyhChqDt)).getTime() : 0,
      payment.PyhDate ? startOfDay(new Date(payment.PyhDate)).getTime() : 0,
    ),
  );
  const valid = isValid(date) && date >= minDate;

  const save = async () => {
    if (!valid || saving) return;
    setSaving(true);
    try {
      const result = await updatePaymentClearingDate(
        payment.PyhSeq,
        format(date, "yyyy-MM-dd"),
      );
      if (result.Code !== 0) {
        SnackbarUtils.warning(result.InternalMessage || result.UserMessage);
        return;
      }
      SnackbarUtils.success(result.UserMessage);
      await onSaved();
    } catch (error) {
      SnackbarUtils.error(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open
      onClose={saving ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="clearing-date-title"
      aria-describedby="clearing-date-description"
    >
      <DialogTitle id="clearing-date-title">
        {translate("ra.field.Clearing Date")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="clearing-date-description">
          {translate(
            paymentPeriodClosed(payment, settingAll)
              ? "ra.info.clearingDateClosedPeriod"
              : "ra.info.clearingDatePrinted",
          )}
        </DialogContentText>
        <DatePickerFormat
          label={translate("ra.field.Clearing Date")}
          value={date}
          onChange={setDate}
          minDate={minDate}
          disabled={saving}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={save} disabled={saving || !valid} color="primary" variant="contained">
          {translate("ra.action.save")}
        </Button>
        <Button onClick={onClose} disabled={saving} variant="outlined">
          {translate("ra.action.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
